/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minDuration: NonNullable<unknown>, maxDuration: NonNullable<unknown> }} Error_Nav_Duration_Out_Of_BoundsInputs */

const en_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duration out of bounds. Event duration should be between (${i?.minDuration} seconds - ${i?.maxDuration} seconds).`)
};

const fr_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duree hors limites. La duree de l'evenement doit etre comprise entre (${i?.minDuration} secondes - ${i?.maxDuration} secondes).`)
};

const de_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dauer außerhalb des zulässigen Bereichs. Die Ereignisdauer sollte zwischen (${i?.minDuration} Sekunden - ${i?.maxDuration} Sekunden) liegen.`)
};

const it_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Durata fuori limite. La durata dell'evento deve essere compresa tra (${i?.minDuration} secondi - ${i?.maxDuration} secondi).`)
};

const ru_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Продолжительность выходит за пределы допустимых значений. Продолжительность события должна быть в пределах (${i?.minDuration} секунд - ${i?.maxDuration} секунд).`)
};

const es_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duración fuera de límites. La duración del evento debe estar entre (${i?.minDuration} segundos - ${i?.maxDuration} segundos).`)
};

const zh_cn2_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`持续时间超出范围。事件持续时间应介于（${i?.minDuration} 秒 - ${i?.maxDuration} 秒）之间。`)
};

const ja_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`継続時間が範囲外です。イベント継続時間は (${i?.minDuration} 秒 - ${i?.maxDuration} 秒) の範囲でなければなりません。`)
};

const hi_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अवधि सीमा से बाहर है। इवेंट की अवधि (${i?.minDuration} सेकंड - ${i?.maxDuration} सेकंड) के बीच होनी चाहिए।`)
};

const pt_pt2_error_nav_duration_out_of_bounds = /** @type {(inputs: Error_Nav_Duration_Out_Of_BoundsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duração fora dos limites. A duração do evento deve estar entre (${i?.minDuration} segundos - ${i?.maxDuration} segundos).`)
};

/**
* | output |
* | --- |
* | "Duration out of bounds. Event duration should be between ({minDuration} seconds - {maxDuration} seconds)." |
*
* @param {Error_Nav_Duration_Out_Of_BoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_duration_out_of_bounds = /** @type {((inputs: Error_Nav_Duration_Out_Of_BoundsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Duration_Out_Of_BoundsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_duration_out_of_bounds(inputs)
	if (locale === "de") return de_error_nav_duration_out_of_bounds(inputs)
	if (locale === "it") return it_error_nav_duration_out_of_bounds(inputs)
	if (locale === "ru") return ru_error_nav_duration_out_of_bounds(inputs)
	if (locale === "es") return es_error_nav_duration_out_of_bounds(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_duration_out_of_bounds(inputs)
	if (locale === "ja") return ja_error_nav_duration_out_of_bounds(inputs)
	if (locale === "hi") return hi_error_nav_duration_out_of_bounds(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_duration_out_of_bounds(inputs)
	return en_error_nav_duration_out_of_bounds(inputs)
});